import React, { useImperativeHandle, useState } from "react";

import { CardTitle } from "../common";
import MediaDisplay from "../../helpers/MediaDisplay";
import PropTypes from "prop-types";

// Utility function to normalize timestamp (ensure it's available)
const normalizeTimestamp = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleString();
};

const MediaCard = React.forwardRef(
  ({ card, topic, messages, w, h, displayVariant, displayParameters }, ref) => {
    // Define action using the card reference
    const action = (setSelectedCard) => {
      setSelectedCard(card);
    };

    useImperativeHandle(ref, () => ({ action }));

    // Create a safe messages array and derive effectiveLastMessage
    const safeMessages = messages || [];
    const effectiveLastMessage =
      safeMessages.length > 0 ? safeMessages[safeMessages.length - 1] : null;
    const content = effectiveLastMessage ? effectiveLastMessage.content : "";
    const contentType = effectiveLastMessage
      ? effectiveLastMessage.content_type
      : "";

    // Determine timestamp strings
    const ts =
      effectiveLastMessage && effectiveLastMessage.timestamp
        ? normalizeTimestamp(effectiveLastMessage.timestamp).split(", ")
        : ["", ""];

    const sizeKey = `${w}x${h}`;

    const [savedTime, setSavedTime] = useState(0);
    const [wasPlaying, setWasPlaying] = useState(false);

    // Define rendering for each size
    const renderContent = () => {
      if (w === h) {
        return (
          <MediaDisplay
            content={content}
            contentType={contentType}
            savedTime={savedTime}
            setSavedTime={setSavedTime}
            wasPlaying={wasPlaying}
            setWasPlaying={setWasPlaying}
          />
        );
      } else if (w > h) {
        return (
          <div className="flex items-center justify-center w-full h-full">
            <div className="pl-2 flex-1 flex flex-col">
              <CardTitle title={topic.name} />
              <p className="mx-auto text-xs text-gray-500">{ts[0]}</p>
              <p className="mx-auto text-xs text-gray-500">{ts[1]}</p>
            </div>
            <div className="h-full my-auto flex flex-col justify-center w-full">
              <MediaDisplay
                content={content}
                contentType={contentType}
                savedTime={savedTime}
                setSavedTime={setSavedTime}
                wasPlaying={wasPlaying}
                setWasPlaying={setWasPlaying}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="flex flex-col justify-between w-full h-full">
            <MediaDisplay
              content={content}
              contentType={contentType}
              savedTime={savedTime}
              setSavedTime={setSavedTime}
              wasPlaying={wasPlaying}
              setWasPlaying={setWasPlaying}
            />
            <br />
            <div className="flex flex-col mx-auto pb-3">
              <CardTitle title={topic.name} />
              <p className="mx-auto text-xs text-gray-500">{ts[0]}</p>
              <p className="mx-auto text-xs text-gray-500">{ts[1]}</p>
            </div>
          </div>
        );
      }
    };

    return (
      <div className="w-full h-full flex flex-col justify-center bg-gray-50">
        {renderContent()}
      </div>
    );
  }
);

MediaCard.variants = ["default", "detailed", "cover"];
MediaCard.variantParameters = {
  default: {},
  detailed: {},
  cover: {},
};

MediaCard.propTypes = {
  card: PropTypes.object.isRequired,
  topic: PropTypes.object.isRequired,
  messages: PropTypes.array.isRequired,
  w: PropTypes.number.isRequired,
  h: PropTypes.number.isRequired,
};

export default MediaCard;
